import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
import { TranscriptWord } from "~/components/AssetModal/shared/components/TranscriptPanel/components/TranscriptSegmentList/components/TranscriptSegment/components/TranscriptWord";
import { IBMPlexMonoFont } from "~/utils/fonts";
const _TranscriptSegmentText = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { segment } = param;
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: "".concat(IBMPlexMonoFont.variable, " flex flex-wrap py-1 font-mono text-14 leading-6 text-grey-12"),
        children: segment.items.map((item, index)=>{
            if (item.type === "punctuation") {
                return null;
            }
            const nextItem = segment.items[index + 1];
            let text = item.text;
            if ((nextItem === null || nextItem === void 0 ? void 0 : nextItem.type) === "punctuation") {
                text += nextItem.text;
            }
            return /*#__PURE__*/ _jsx(TranscriptWord, {
                item: item,
                children: text
            }, index);
        })
    });
});
_TranscriptSegmentText.displayName = "_TranscriptSegmentText";
export const TranscriptSegmentText = /*#__PURE__*/ memo(_TranscriptSegmentText);
TranscriptSegmentText.displayName = "TranscriptSegmentText";
